import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// config
import { ROLE_NAMES } from '../config';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD, PATH_ROOT } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user?.roleName === ROLE_NAMES.root) {
    return <Navigate to={PATH_ROOT.root} />;
  }

  if (isAuthenticated) {
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  return <>{children}</>;
}
